import { Reveal, SectionHeading } from "@/components/Reveal";

const STEPS = [
    { num: "01", title: "DIAGNÓSTICO", text: "Entendemos onde sua empresa está hoje." },
    { num: "02", title: "ESTRATÉGIA", text: "Definimos o que precisa ser ajustado." },
    { num: "03", title: "IMPLEMENTAÇÃO", text: "Organizamos e desenvolvemos os elementos necessários." },
    { num: "04", title: "ENTREGA", text: "Você recebe uma estrutura mais profissional e pronta para utilizar." },
];

const HowItWorks = () => (
    <section
        id="como-funciona"
        data-testid="como-funciona-section"
        className="py-24 sm:py-32 bg-[#0a0a0e] border-y border-line/60 scroll-mt-16"
    >
        <div className="mx-auto max-w-7xl px-5 sm:px-8">
            <SectionHeading
                eyebrow="Como funciona"
                title={
                    <>
                        Simples para você.{" "}
                        <span className="text-gold-grad">Estratégico para o seu negócio.</span>
                    </>
                }
            />

            <div className="mt-16 relative">
                <div className="hidden lg:block absolute top-[26px] left-[12%] right-[12%] h-px bg-gradient-to-r from-transparent via-gold/40 to-transparent" />

                <div className="grid lg:grid-cols-4 gap-10 lg:gap-6">
                    {STEPS.map((s, i) => (
                        <Reveal key={s.num} delay={0.1 * i}>
                            <div
                                data-testid={`step-${s.num}`}
                                className="relative flex lg:flex-col items-start lg:items-center gap-6 lg:gap-0 lg:text-center pl-8 lg:pl-0"
                            >
                                <span className="lg:hidden absolute left-0 top-1 bottom-0 w-px bg-gradient-to-b from-gold/50 to-transparent" />
                                <div className="absolute lg:static -left-[13px] lg:left-auto top-0 w-[52px] h-[52px] rounded-full border border-gold/40 bg-bg flex items-center justify-center font-mono2 text-sm text-gold shadow-[0_0_24px_rgba(212,175,55,0.15)]">
                                    {s.num}
                                </div>
                                <div className="flex flex-col lg:items-center gap-2.5 lg:mt-6">
                                    <h3 className="font-display text-lg font-bold tracking-wide text-ink">
                                        {s.title}
                                    </h3>
                                    <p className="text-sm text-ink2 leading-relaxed max-w-[260px]">{s.text}</p>
                                </div>
                            </div>
                        </Reveal>
                    ))}
                </div>
            </div>
        </div>
    </section>
);

export default HowItWorks;
